var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompactView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 50.21H9.88C6.63257 50.21 4 47.5774 4 44.33V27.105M27 50.21H44.12C47.3674 50.21 50 47.5774 50 44.33V27.105M27 50.21V4M27 4H44.12C47.3674 4 50 6.63257 50 9.88V27.105M27 4H9.88C6.63257 4 4 6.63257 4 9.88V27.105M50 27.105H4",
    stroke: "#8A96A3",
    strokeWidth: 6.82,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactView);
export default __webpack_public_path__ + "static/media/CompactView.2f34ac3a8cbef3b4079c2304e2e168cb.svg";
export { ForwardRef as ReactComponent };